import { autoserialize } from 'cerialize';

export class ApprovalRequestType {
  @autoserialize
  dtoClassName: string;

  @autoserialize
  serviceQualifier: string;
}
